// import adminFeedRulesLoader from '@/mixins/spawner/loaders/admin/orm/feedRules-loader';
// import adminFeedsLoader from '@/mixins/spawner/loaders/admin/orm/feeds-loader';
// import adminJobsLoader from '@/mixins/spawner/loaders/admin/orm/jobs-loader';
// import adminListsLoader from '@/mixins/spawner/loaders/admin/orm/lists-loader';
// import adminNetworksLoader from '@/mixins/spawner/loaders/admin/orm/networks-loader';
// import adminProfilesLoader from '@/mixins/spawner/loaders/admin/orm/profiles-loader';
import adminSchemasLoader from '@/mixins/spawner/loaders/admin/schemas-loader';
// import adminWikipediaPagesLoader from '@/mixins/spawner/loaders/admin/orm/wikipediaPages-loader';

export default {

  data() {
    return {
      debug: this.$store.get('debug/orm@debug'),
      showCount: this.$store.get('debug/orm@showCount'),
    };
  },

  mixins: [
    // adminFeedRulesLoader,
    // adminFeedsLoader,
    // adminJobsLoader,
    // adminListsLoader,
    // adminNetworksLoader,
    // adminProfilesLoader,
    // adminWikipediaPagesLoader,
    //
    adminSchemasLoader,
  ],

  methods: {
    loadSpawnerAdminCache(fromDb) {
      if (this.$auth.check()) {
        /* ORM */
        // this.loadSpawnerAdminFeedRules(fromDb);
        // this.loadSpawnerAdminFeeds(fromDb);
        // this.loadSpawnerAdminJobs(fromDb);
        // this.loadSpawnerAdminLists(fromDb);
        // this.loadSpawnerAdminNetworks(fromDb);
        // this.loadSpawnerAdminProfiles(fromDb);
        /* ORM */
        // this.loadSpawnerAdminWikipediaPages(fromDb);
        /* DB */
        this.loadSpawnerAdminSchema('forms');
        /* DB */
      }
    },
  },

  mounted() {
    this.loadSpawnerAdminCache(false);

    Bus.$on('refresh_cache_admin', () => {
      this.loadSpawnerAdminCache(true);
    });
  },

  beforeDestroy() {
    Bus.$off('refresh_cache_admin');
  },
};
